angular.module('impactx.invoice').controller('InvoiceEditItemsCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    'BasketService',
    'blhId',
    'items',
    InvoiceEditItemsCtrl
]);

function InvoiceEditItemsCtrl($scope, dataGen, $mdDialog, ToastService, TranslationService, BasketService, blhId, items) {
    var ctrl = this;

    $scope.blhId = blhId;
    $scope.items = items;

    function getData() {
        $scope.trns = {
            save: TranslationService.get('save'),
            abort: TranslationService.get('abort'),
            required: TranslationService.get('required'),
        };
        dataGen.getData($scope, {blhId: $scope.blhId}, '/invoice/complaint/edit/items/view').then(function () {
            $scope.data.items = [];
            $scope.items.forEach((selection) => $scope.data.items.push({id: selection.id, type: selection.type}));
        });
    };

    ctrl.save = function () {
        dataGen.postAsForm({}, {data: $scope.data}, '/invoice/complaint/edit/items/save').then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    };

    getData();

}